module.exports = __webpack_public_path__ + "media/images/front/products/adspray/index-banner-03a251d83f161dab858cdfa2c2441488.jpg";